import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import Login from "./containers/Login";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/test",
    element: <div>test</div>,
  },
]);
